/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameTreatmentPlanDto
 */
export interface RenameTreatmentPlanDto {
    /**
     * New custom name for the treatment plan
     * @type {string}
     * @memberof RenameTreatmentPlanDto
     */
    customName: string;
}

/**
 * Check if a given object implements the RenameTreatmentPlanDto interface.
 */
export function instanceOfRenameTreatmentPlanDto(value: object): value is RenameTreatmentPlanDto {
    if (!('customName' in value) || value['customName'] === undefined) return false;
    return true;
}

export function RenameTreatmentPlanDtoFromJSON(json: any): RenameTreatmentPlanDto {
    return RenameTreatmentPlanDtoFromJSONTyped(json, false);
}

export function RenameTreatmentPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameTreatmentPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'customName': json['customName'],
    };
}

export function RenameTreatmentPlanDtoToJSON(json: any): RenameTreatmentPlanDto {
    return RenameTreatmentPlanDtoToJSONTyped(json, false);
}

export function RenameTreatmentPlanDtoToJSONTyped(value?: RenameTreatmentPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customName': value['customName'],
    };
}

